import {put, takeEvery} from 'redux-saga/effects';
import {RULES_RESET, RULES_SET} from '../reducers2/rules';
import {TYPES as CURRENT_USER_TYPES} from '../creators/currentUser';
import {subscribeRoom, unsubscribeRoom} from '../creators/rooms';
import {subscribeUserStatus, unsubscribeUserStatus} from '../creators/user.friends';
import {subscribeUnreadNotifications, unsubscribeUnreadNotifications} from '../creators/user.unreadNotification';
import history from '../libs/history';
import ability from "../ability";
import createLink from "../libs/createLink";
// import * as Sentry from "@sentry/react";
import _ from "lodash";
import qs from "qs";

// import {observerUserStatus,observerUserNotifications,observerRooms} from '../libs/socket';

let currentUserId = null;

function* resetRelated() {
    yield put({type: RULES_RESET});
    yield put({type: "CURRENT_USER_RESET"});
    localStorage.removeItem(process.env.REACT_APP_TOKEN_NAME);
    localStorage.removeItem(`${process.env.REACT_APP_TOKEN_NAME}_gp`);
    sessionStorage.removeItem(`${process.env.REACT_APP_TOKEN_NAME}_alert`);

    // observerUserStatus.unsubscribe();
    // observerUserNotifications.unsubscribe();
    // observerRooms.unsubscribe();

    yield put(unsubscribeRoom());
    yield put(unsubscribeUserStatus());
    yield put(unsubscribeUnreadNotifications());
    // Sentry.configureScope(scope => scope.setUser(null));
    currentUserId = null;
}


export function* fetchSuccess(action) {
    try {
        // console.log(gen);
        let isAlert = sessionStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_alert`);
        let isToggle = _.get(action, "payload.setting.displayBigPlan") || false
        localStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_gp`, isToggle);

        let source = _.get(action, "payload.source") || "voissa";
        localStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_source`, source);

        // Sentry.setUser({
        //     _id: action.payload._id,
        //     username: _.get(action.payload, "username"),
        //     email: _.get(action.payload, "email.address")
        // });
        window._userId = action.payload._id;
        if (action.payload && action.payload.rules) {
            let rules = action.payload.rules;
            let currentUser = action.payload;
            delete action.payload.rules;

            yield put({type: RULES_SET, rules});
            yield put({type: "CLICK_CTA_UPDATE", ...currentUser});

            // yield put({type: "CURRENT_USER_TEST", data : {test : "lalap"}});
            if (rules) yield ability.update(rules);
            if (action.payload._id !== currentUserId) {
                currentUserId = action.payload._id;
                yield put(subscribeRoom());
                yield put(subscribeUserStatus());
                yield put(subscribeUnreadNotifications());
            }

            // observerUserStatus.update();
            // observerUserNotifications.update();
            // observerRooms.update();
        }

        if (action.payload && !action.payload.customer.subscribed ) {
            if([2,3,4].includes(action.payload.profile.gender)){
                action.payload.modalSubscribed = {
                    modal : false,
                    modalName : "",
                    link : createLink("userMeSettingsAbonnement")
                }
            }
            else{
                action.payload.modalSubscribed = {
                    modal : true,
                    modalName : "ModalSubscription",
                    link : ""
                }
            }
        }

        if (action.payload && action.payload.role === "emailUnconfirmed" && action.payload.profile.isCompleted && !isAlert) {
            let {actionToken} = qs.parse(history.location.search, {ignoreQueryPrefix: true});
            // history.push('/first-connexion');
            // console.log(action.payload);
            if(!actionToken){
                sessionStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_alert`, true);
                history.push(createLink("userMe"));
                //history.push('/first-connexion')
            }
        }
        if (action.payload && !action.payload.profile.isCompleted && !isAlert) {
            let {actionToken} = qs.parse(history.location.search, {ignoreQueryPrefix: true});
            if(!actionToken){
                history.push('/first-connexion');
            }

            // history.push(createLink("userMe"));
        }
        /*if (action.payload && action.payload.profile.isCompleted === false && !isAlert) {
            let {actionToken} = qs.parse(history.location.search, {ignoreQueryPrefix: true});
            // history.push('/first-connexion');
            // console.log(action.payload);
            if(!actionToken){
                //history.push(createLink("userMe"));
                history.push('/first-connexion')
            }
        }*/

    } catch (error) {
        console.log(error, "error");
        // yield put({type: LOGIN_USER_ME_FAIL, payload: action.payload.rules});
        resetRelated();
    }
}

export function* watchCurrentUser() {
    yield takeEvery(CURRENT_USER_TYPES.GET_ONE_SUCCESS, fetchSuccess);
    yield takeEvery(CURRENT_USER_TYPES.GET_ONE_FAIL, resetRelated);
}

export default watchCurrentUser;
